import React, { useState, useEffect } from "react";
import { Col, Container, Row, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../Style.css";
import AdminHeader from "../../common/Header";
import List from "../../components/listing/List";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import axios from "axios";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import { useSelector } from "react-redux";
import { apiCall } from "../../../components/common/ApiCall";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const loggedInUser = useSelector((state) => state.auth.user);
  console.log(loggedInUser)
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  // Fetch Blogs
  const fetchBlogs = async () => {
    try {
      const response = await axios.post(`${baseUrl}/admin/blogs`,
        {
          page_number: currentPage,
          page_size: 20,
          order_by: "ASC",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.statusType === "SUCCESS") {
        setBlogs(response.data.blogs);
      } else {
        showToast("Failed to fetch blogs", { type: "error" });
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
      showToast("Error occurred while fetching blogs", { type: "error" });
    }
  };

    useEffect(() => {
      fetchBlogs();
    }, [currentPage]);

    const handlePageChange = (page) => {
      setCurrentPage(page);
    };


  // Handle Delete Blog
  const handleDelete = async (blogId) => {
    try {
      const response = await axios.delete(`${baseUrl}/admin/deleteBlog/${blogId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.statusType === "SUCCESS") {
        setBlogs(blogs.filter((blog) => blog.id !== blogId));
        showToast("Blog deleted successfully", { type: "success" });
      } else {
        showToast("Failed to delete blog", { type: "error" });
      }
    } catch (error) {
      console.error("Error deleting blog:", error);
      showToast("Error occurred while deleting blog", { type: "error" });
    }
  };

// Handle Toggle Publish/Disable
const handleToggleEnable = async (itemId) => {
  const enabled = !blogs.find((blog) => blog.id === itemId).is_home;
  console.log("your enables is", enabled);
  const response = await apiCall(
    `${baseUrl}/admin/blog/home/state`,
    "put",
    {
      id: itemId,
      is_home: enabled,
    },
    token
  );
  if (response) {
    console.log("your response is", response);
    if (response.statusType === "SUCCESS") {
      // Update the state of the blogs
      const updatedBlogs = blogs.map((blog) => {
        if (blog.id === itemId) {
          blog.is_home = enabled;
        }
        return blog;
      });
      setBlogs(updatedBlogs);
      showToast(
        enabled ? "Blog Enabled Successfully" : "Blog Disabled Successfully",
        { type: "success" }
      );
    }
  }
};

  const columns = [
    { displayName: "S.No.", render: (item, index) => ((currentPage-1)*10) + index + 1 },
    { displayName: "Title", key: "title" },
    { displayName: "Author", key: "author" },
    {
      displayName: "Publish Date",
      render: (item) => {
        const date = new Date(item.publish_date);
        return date.toLocaleDateString("en-US"); // Format as MM/DD/YYYY
      },
    },
  ];

  const breadcrumbItems = [
    { label: "", link: "/", icon: "fa-solid fa-house" },
    { label: "Content Management", link: "/user" },
    { label: "Blogs", link: "/blog", active: true },
  ];

  return (
    <>
      <Notification />
      <Container>
        <BreadCrumb items={breadcrumbItems} />
        <Row>
          <Col lg={4} md={4} sm={12}>
            <AdminHeader />
          </Col>
          <Col lg={8} md={8} sm={12} style={{ minHeight: "50vh" }}>
            {blogs.length === 0 ? (
              <div>
                <p>No blogs found. Click "Create" to add a new blog.</p>
                <Link to="/blog/add-blog">
                  <Button variant="primary">Create</Button>
                </Link>
              </div>
            ) : (
              <List
                title="Blogs"
                data={blogs}
                columns={columns}
                button="Create"
                to="/blog/add-blog"
                route="blog"
                handleDelete={handleDelete}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
                handleToggleEnable={handleToggleEnable}
              />
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Blog;